import React, { useState } from 'react';
import cx from 'classnames';
import ShowMoreMenu from 'lib/ShowMoreMenu';
import SVG from 'react-inlinesvg';
import eraseSvg from 'assets/icons/erase.svg';
import cloneSvg from 'assets/icons/copy.svg';
import editSvg from 'assets/icons/edit.svg';
import warningSvg from 'assets/icons/warning.svg';
import Button, { Color, Size } from 'lib/Button';
import Modal from 'lib/Modal';
import SectionDivider from 'components/pages/Planner/SectionDivider';
import { ProductOptionsMenuProps } from './ProductOptionsMenu.types';

const ProductOptionsMenu: React.FC<ProductOptionsMenuProps> = ({
  isOpen,
  onToggle,
  onKeepAndDuplicate,
  onDisableAndDuplicate,
  status,
  onChangeOfStatus,
}) => {
  const [isToggleModalOpen, setIsToggleModalOpen] = useState<boolean>(false);

  const isActiveStatus = status === 'ACTIVE';

  return (
    <>
      <ShowMoreMenu
        isOpen={isOpen}
        onToggle={onToggle}
        svgClassName="rotate-90 cursor-pointer"
        contentWidth="min-w-[285px]"
        align="start"
      >
        <button
          className="py-2 px-2 w-full flex justify-start items-center text-essential-secondary body-base space-x-2 enabled:hover:bg-primary-50"
          type="button"
          onClick={onKeepAndDuplicate}
        >
          <p className="w-10/12 text-left body-base truncate whitespace-nowrap overflow-hidden">
            Duplicate & set original as active
          </p>
          <SVG src={editSvg} className="w-4 h-4" />
        </button>
        <button
          className="py-2 px-2 w-full flex justify-start items-center text-essential-secondary body-base space-x-2 enabled:hover:bg-primary-50"
          type="button"
          onClick={onDisableAndDuplicate}
        >
          <p className="w-10/12 text-left body-base truncate whitespace-nowrap overflow-hidden">
            Duplicate & set original as disabled
          </p>
          <SVG src={cloneSvg} className="w-4 h-4" />
        </button>
        <SectionDivider />
        <button
          className={cx(
            'py-2 px-2 w-full flex justify-start items-center body-base space-x-2 enabled:hover:bg-primary-50',
            {
              'text-red-900': isActiveStatus,
              'text-green-700': !isActiveStatus,
            },
          )}
          type="button"
          onClick={() => setIsToggleModalOpen(true)}
        >
          <p className="w-10/12 text-left body-base truncate whitespace-nowrap overflow-hidden">
            {isActiveStatus ? 'Disable' : 'Activate'}
          </p>
          <SVG src={eraseSvg} className="w-4 h-4" />
        </button>
      </ShowMoreMenu>
      <Modal
        dataTestId="product-options-menu-modal"
        title={
          isActiveStatus
            ? 'Are you sure you want to disable this product?'
            : 'Are you sure you want to enable this product?'
        }
        text={isActiveStatus ? 'This product template will be disabled' : 'This product template will be enabled'}
        isOpen={isToggleModalOpen}
        onClose={() => setIsToggleModalOpen(false)}
        icon={warningSvg}
        actionButtons={
          <>
            <Button
              label="Cancel"
              size={Size.MEDIUM}
              color={Color.SECONDARY}
              onClick={() => setIsToggleModalOpen(false)}
            />
            <Button
              label={isActiveStatus ? 'Disable' : 'Enable'}
              size={Size.MEDIUM}
              color={Color.PRIMARY}
              onClick={() => {
                setIsToggleModalOpen(false);
                onChangeOfStatus();
              }}
            />
          </>
        }
      />
    </>
  );
};

export default ProductOptionsMenu;
